<ng-container *ngIf="data.img !== null; else empty">
  <i class="fal fa-image fa-2x vehicle-images-icon" (click)="openImageModal()" [title]="data.title"></i>
  <!-- <div *ngIf="viewImage">
    <img
      id="image"
      class="d-none"
      [src]="data.img"
      [alt]="data.imgAlt"
      (imageResolved)="imageResolved()"
      #image
      appSecureImage
    />
  </div> -->
</ng-container>
<ng-template #empty>-</ng-template>

<ng-template #photoDialog let-context>
  <nb-card class="reject-reason-dialog">
    <nb-card-header>تصویر سلفی / کارت ملی</nb-card-header>

    <nb-card-body>
      <ul class="list" #imageList (click)="showImages()">
        <li>
          <img [src]="context.selfie"
           alt="" appSecureImage />
        </li>

        <li>
          <img [src]="context.identity"
          alt="" appSecureImage />
        </li>
      </ul>
    </nb-card-body>
  </nb-card>
</ng-template>
